export const getDefaultSortOrderByParsedValues = (
  searchString: string,
  array: string[]
): 'descend' | 'ascend' | null | undefined => {
  // Проверяем, есть ли в массиве строка, которая совпадает с searchString, начиная со второго символа
  for (const str of array) {
    if (str.slice(1) === searchString) {
      // Возвращаем 'descend' если первый символ '-', 'ascend' если '+', иначе undefined
      if (str[0] === '-') return 'descend';
      if (str[0] === '+') return 'ascend';
      return undefined;
    }
  }
  return undefined; // Если не найдено
};
